import React, { useContext, useEffect, useState } from 'react'
import {
  YEAR_MIN,
  YEAR_MAX,
  champSeriesDateRanges,
  CURRENT_YEAR,
} from '../../../../Config/League/league.config'
import { YearSelect } from '../YearSelect'
import { PlayerProfileContext } from '../../../../Context'
import { SeasonType } from '../../../../Routing/urls'
import { SeasonTypeRow } from './SeasonTypeRow'
import { SelectorCon } from './styles'

type SeasonSelectorProps = {
  color?: string
  allYears: number[] | undefined
  isActive: boolean
}

export const SeasonSelector: React.FC<React.PropsWithChildren<SeasonSelectorProps>> = ({
  allYears,
  isActive
}) => {
  const { seasonStatsArrays, onStatsDropdownChange, seasonSelect } =
    useContext(PlayerProfileContext)!
  const [yearMin, setYearMin] = useState(YEAR_MIN)
  const [yearMax, setYearMax] = useState(YEAR_MAX)

  useEffect(() => {
    findYearRange()
  }, [allYears, seasonStatsArrays])

  const findYearRange = () => {
    if (!allYears) return [YEAR_MIN, YEAR_MAX]
    if (seasonSelect.year >= 2023 && allYears.length > 0) {
      setYearMin(allYears[0])
      if(!isActive){ //Retired, use last year played
        setYearMax(allYears[allYears.length - 1])
        return
      }
      //Factor in champ series
      const now = Math.floor(Date.now() / 1000)
      const csRange = champSeriesDateRanges[CURRENT_YEAR]
      if (now >= csRange.startTime && now <= csRange.endTime) {
        setYearMax(allYears[allYears.length - 1] + 1)
        return
      } else {
        setYearMax(allYears[allYears.length - 1])
      }
      return
    }
    if (allYears?.length > 0) {
      //No Champ Series
      setYearMin(allYears[0])
      setYearMax(allYears[allYears.length - 1])
      return allYears
    }
    return
  }

  const onChangeYear = (year: number) => {
    onStatsDropdownChange({
      seasonType: 'regular',
      year: year,
    })
  }

  const onChangeType = (seasonType: SeasonType) => {
    onStatsDropdownChange({
      seasonType: seasonType,
      year: seasonSelect.year,
    })
  }

  return (
    <SelectorCon>
      <div>Season:</div>
      <YearSelect
        min={yearMin}
        max={yearMax}
        current={seasonSelect.year}
        onChangeYear={onChangeYear}
      />
      <SeasonTypeRow
        seasonType={seasonSelect.seasonType}
        disablePostSeason={seasonSelect.year === 2020 || !seasonStatsArrays.post} //2020 only year without postseason
        disableChampSeries={seasonSelect.year < 2023 || !seasonStatsArrays.champseries}
        onSelectSeasonType={onChangeType}
      />
    </SelectorCon>
  )
}
